class ErrorCode {
  static WRONG_VERSION = -100;

  static ACCOUNT_LOCKED = -200;

  // On May 2020, following the covid-19 pandemic, Shizen prvided a free version
  // allowing access to only one pre-set GW, problems, actions and one DMP indicator
  // any other usage is restricted if the CompanyParameters 'covidVersion' is set to 1
  static COVID_RESTRICTED = -300;

  /**
   * All messages which should not trigger a toastr error message
   */
  static NO_MSG_CODES = [ErrorCode.WRONG_VERSION, ErrorCode.ACCOUNT_LOCKED, ErrorCode.COVID_RESTRICTED];

  // Login error codes
  // NOTE: Synced with server/classes/ShizenErrorCode.php
  // => const ([A-Z_]+) = ["']?([\-]?[0-9]+)["']?;  ==>  static $1 = $2;
  static LOGIN_WRONG_ID = -1001;

  static LOGIN_WRONG_PWD = -1002;

  static LOGIN_SSO_NOT_ENABLED = -1003;

  static LOGIN_SSO_USER_NOT_FOUND = -1004;

  static CHECK_LOGIN_NO_USER = -1005;

  static LOGIN_SSO_WRONG_PARAMS = -1010;

  static LOGIN_SSO_IDP_FAILED = -1011;

  // Data from IdP doesn't contain the prop in settings
  static LOGIN_SSO_WRONG_MAPPER_IDP_PROP = -1012;

  static LOGIN_SSO_MAPPER_USER_NOT_FOUND = -1013;

  static LOGIN_SSO_SAML_REQUIRED = -1014;

  static LOGIN_SSO_OIDC_REQUIRED = -1015;

  // Trying to create new user but property missing from IdP
  static LOGIN_SSO_NEW_USER_PROPS_MISSING = -1016;

  // Trying to create new user but specified 'group' doesn't match any team in Shizen
  static LOGIN_SSO_NEW_USER_TEAM_NOT_FOUND = -1017;

  static LOGIN_SSO_NEW_USER_CREATION_ERROR = -1018;

  // A login attempt was made lass than 2 seconds after the last one
  static LOGIN_LAST_ATTEMPT_TOO_CLOSE = -1019;

  static CONFIG_STARTUP_TEMPLATE_PAGES = -2000;

  static CONFIG_STARTUP_TEMPLATE_PLANNINGS = -2001;

  static CONFIG_STARTUP_TEMPLATE_SCHEMES = -2002;

  static CONFIG_CANT_DELETE_SELF = -2015;

  static CONFIG_CANT_DELETE_ADMIN_TEAM = -2016;

  static CONFIG_CANT_REMOVE_LAST_ADMIN = -2017;

  // Trying to edit a cfg page widgets linked to a template
  static CFG_PAGE_EDITING_SYNCED_TEMPLATE = -4001;

  static CFG_PAGE_CANT_MAKE_TEMPLATE_FROM_PAGE = -4002;

  static CFG_PAGE_ALREADY_HAS_TEMPLATE = -4003;

  // GW error codes
  static GW_NO_ACCESS_TO_GW = -5001;

  // TEAM error codes
  static TEAM_NOT_FOUND = -6001;

  static CANNOT_SAVE_TEAM_PARAMETERS = -6002;

  // User error codes
  static EMAIL_ALREADY_USE = -7001;

  static USER_NOT_FOUND = -7002;

  // Generic error codes
  static NOTHING_TO_UPDATE = -10001;

  static VALIDATOR_ERROR = -10002;

  static UNAUTHORIZED = -10006;
}

export default ErrorCode;
